<pia3-client-selector [selectorMode]="selectorMode" (clientSelected)="_clientSelected($event)"></pia3-client-selector>
